import React from 'react'
import styles from './Style.module.css'
import { BtnPrimaryWithIcon } from '../Buttons/BtnWithIcon/BtnPrimaryWithIcon'
import WhatsAppIcon from '../Icons/WhatsAppIcon'
import { BtnSecondaryWithIcon } from '../Buttons/BtnWithIcon/BtnSecondaryWithIcon'
import { Phone } from 'lucide-react'

const OutletCTA = ({whatsappNumber, contactNumber, customClass}) => {

    const whatsapp = () => {
        window.open(`https://wa.me/${whatsappNumber}`, "_blank");
    };

    const call = () => {
        window.location.href = `tel:${contactNumber}`;
    };

  return (
    <div className={`${styles.ctaContainer} ${customClass}`}>
        {whatsappNumber && (
        <BtnPrimaryWithIcon 
        icon={<WhatsAppIcon color="white" />}
        label={whatsappNumber} 
        customClass={styles.contactOutletBtn}
        handleClick={() => whatsapp(whatsappNumber)}
        />
        )}
        {contactNumber && (
        <BtnSecondaryWithIcon 
        icon={<Phone size={16} color="#BC6B38" />}
        label={contactNumber}
        customClass={styles.contactOutletBtn}
        handleClick={() => call(contactNumber)}
        />
        )}
      </div>
  )
}

export default OutletCTA